import { useLocation, useSearchParams } from "react-router-dom";

import { useEffect, useState } from "react";
import { Card, Result, Loading } from "../components/";

export default function ResultPage() {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(location);
  const image = searchParams.get("image");
  const name = searchParams.get("name");
  const id = searchParams.get("id");
  const list = { image: image, name: name };
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1250);
  }, []);
  if (loading) {
    return <Loading />;
  }

  return (
    <div className="container">
      <Result image={image} name={name} id={id}>
        <Card list={list} resultPage />
      </Result>
    </div>
  );
}
